import "@components/wrapLayout/style/wrap-layout.less";

import Footer from "@components/footer/Footer";
import Loading from "@components/loading/Loading";
import NoviceGuidance from "@components/novice-guidance/Index";
import { flatRoutes } from "@routes/wrapRoutes";
import { parseUrl } from "@utils/utils";
import React, { FC, Suspense, useEffect } from "react";
import { Redirect, Route,Switch, useHistory,useLocation } from "react-router-dom";

import useHox from "@/hoxModel/HoxModel";
/**
 * @description 布局容器
 * */
const WrapLayout: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const showFooterPath = ['/home']
  const [{ routes }] = flatRoutes;
  const {state} = useHox()
  useEffect(()=>{
    changeTitle(history.location);
    history.listen((a,b)=>{
      changeTitle(a);
    })
  }, [])
  
  const changeTitle = (location_: any)=> {
    if (location_.pathname==='/covi-report') {
      document.title = parseUrl(decodeURI(location_.search)).name
    } else if (location_.pathname==='/community-report') {
      document.title = parseUrl(decodeURI(location_.search)).metaTitle
    } else if (location_.pathname==='/covi-monit') {
      document.title = '核酸采样点'
    } else if (location_.pathname==='/covi-monit-map') {
      document.title = '核酸采样点查询'
    } else if (location_.pathname==='/insight-detail') {
      document.title = '价值评估'
    } else {
      document.title = '点点通'
    }
  }
  return (
    <div className="wrapLayout">
      <div className="main">
        <Suspense fallback={<Loading />}>
          <Switch>
            {
              routes.map((route: any) => {
                return (
                  <Route
                    path={route.path}
                    key={`${route.uniqueKey}-${route.title}`}
                    exact={route.exact}
                    render={(props) => <route.component props={props} routes={routes}/>}
                  />
                )
              })
            }
            <Redirect to="/index"/>
          </Switch>
        </Suspense>
        {
          state.loading&&<div className="loading-wrap">
            <Loading />
          </div>
        }
      </div>
      {
        showFooterPath.includes(location?.pathname)?(
          <div className="footer">
            <Footer/>
          </div>
        )
        :null
      }
      {/* <NoviceGuidance /> */}
    </div>
  )
};
export default React.memo(WrapLayout);
